import { defineStore } from 'pinia';

export interface ICatalogModule {
  fromUserFlow: string;
  fromUserCameFrom: string;
}

export const useCatalogStore = defineStore('catalog', {
  state: (): ICatalogModule => ({
    fromUserFlow: '',
    fromUserCameFrom: ''
  }),
  actions: {
    setFromUserFlow(fromUserFlow: string, fromUserCameFrom?: string) {
      this.fromUserFlow = fromUserFlow;
      this.fromUserCameFrom = fromUserCameFrom;
    }
  }
});
